module.exports = __webpack_public_path__ + "fe55488.woff";